export default __webpack_public_path__ + "static/media/Getwell Ammended By Laws.f869a01e.pdf";